/**
 * Nova3D — the real Nova, in the setup flow.
 *
 * ONB-5b. The wizard introduced Nova and pitched Passport with the flat
 * 2D expression set, which is fine for a 64px mood beside a sentence
 * and wrong for the two screens whose whole job is "this is her". Those
 * get the Three.js Nova from the Assistant page.
 *
 * Lazy on purpose: the engine is ~675 KB plus a 2 MB model, and eleven
 * of the thirteen steps never need it. React.lazy keeps it out of the
 * wizard chunk until the first 3D step mounts; the 2D expression stands
 * in while it streams and stays if WebGL is unavailable.
 */
import { lazy, Suspense } from 'react';
import { NovaExpression, type NovaExpressionId } from '@/components/nova/kit';

const NovaChat3D = lazy(() =>
  import('@/components/nova/NovaChat3D').then((m) => ({ default: m.NovaChat3D })),
);

export function Nova3D({
  state = 'happy',
  size = 220,
  fallbackMood = 'happy',
  className,
}: {
  /** Chat-mood id, mapped to an engine expression by NovaChat3D. */
  state?: string;
  /** Render width in px; height is 4:5. */
  size?: number;
  /** 2D expression shown while the engine streams or without WebGL. */
  fallbackMood?: NovaExpressionId;
  className?: string;
}) {
  const fallback = (
    <div
      className={`flex items-center justify-center ${className ?? ''}`}
      style={{ width: size, height: Math.round(size * 1.25) }}
    >
      <NovaExpression id={fallbackMood} size={Math.round(size * 0.72)} />
    </div>
  );
  return (
    <Suspense fallback={fallback}>
      <NovaChat3D state={state} size={size} fallback={fallback} className={className} interactive />
    </Suspense>
  );
}

export default Nova3D;
